import {
    COMPARE_STRINGS,
    COMPARE_TAGS,
    MONEY_STRING,
    PRICE_SELECTORS
} from './constants.js';
import { formatCurrency, formatTemplate } from './utils';

export default class Pricing {
    MONEY_STRING = MONEY_STRING;
    PRICE_SELECTORS = PRICE_SELECTORS;
    COMPARE_TAGS = COMPARE_TAGS;
    COMPARE_STRINGS = COMPARE_STRINGS;

    constructor({ selectors, props, classes, container }) {
        this.selectors = selectors;
        this.props = props;
        this.classes = classes;
        this.container = container;

        if (this.selectors.price) this.PRICE_SELECTORS = this.selectors.price;

        this.priceElements = this.findPrices();
        this.priceContainer = this.findPriceContainer();
    }

    findPrices() {
        /*
            Find and return product page price elements
            - Filter out parent elements
            - Separate main price elements
            - Separate compareison price elements
        */
        let parent = this.container;
        let prices = [];
        let step = 0;

        do {
            prices = parent.querySelectorAll(this.PRICE_SELECTORS);
            parent = parent.parentElement;
            step++;
        } while (!prices.length && step <= this.props.stepLimiter);

        return prices;
    }

    rebuildPrices() {
        // If prices aren't found, we will want to rebuild prices
        if (this.mainPrices.length && !document.contains(this.mainPrices[0])) {
            this.priceElements = this.findPrices();
            this.priceContainer = this.findPriceContainer();
        }
    }

    get _childrenPrices() {
        /*
            Find and return the inner most price elements
            - Filters through the price list
            - Remove prices containing additional price elements
        */
        const childrenPrices = [...this.priceElements].filter(
            elem => !elem.querySelectorAll(this.PRICE_SELECTORS).length
        );
        return childrenPrices;
    }

    get mainPrices() {
        /*
            Find and return the inner most price elements
            - Filters through the price list
            - Remove prices containing additional price elements
        */
        return [...this._childrenPrices].filter(
            elem => !this._filterComparePrices(elem)
        );
    }

    get comparePrices() {
        /*
            Find and return the inner most price elements
            - Filters through the price list
            - Remove prices containing additional price elements
        */
        return [...this._childrenPrices].filter(elem =>
            this._filterComparePrices(elem)
        );
    }

    _filterComparePrices = (elem = {}) => {
        /*
            Return true if element is used for price comparisons
            - Returning true if either:
            - Element uses traditional comparison tags
            - Element contains traditional class strings
            - Also search the immediate parent element
        */
        const elements = this.COMPARE_TAGS.some(tag => {
            return (
                elem.tagName?.toLowerCase() === tag ||
                elem.parentElement?.tagName?.toLowerCase() === tag
            );
        });
        const classes = this.COMPARE_STRINGS.some(className => {
            return (
                elem.className?.includes(className) ||
                elem.parentElement?.className?.includes(className)
            );
        });

        return elements || classes;
    };

    buildPrice = price => {
        const template = formatTemplate(this.props.moneyFormat);
        const currency = formatCurrency(this.props.moneyFormat, price);
        if (currency) {
            return template.replace(this.MONEY_STRING, currency);
        }
        return price;
    };

    findPriceContainer() {
        /*
            Container finder
            - Repeatedly search through parent elements until a top-most relevant parent is found
            Receive an element, with a search string
        */
        let string = this.selectors.priceString;
        let currentElement = this.mainPrices[0];
        let parent;

        try {
            parent = currentElement.parentElement;
        } catch (e) {
            window.console.warn('ReCharge: Price has no parent container');
            window.console.log({
                'this.pricing.mainPrices': this.mainPrices,
                'this.selectors.price': this.selectors.price
            });
        }

        do {
            currentElement = parent;
            parent = currentElement?.parentElement;
        } while (
            parent?.className?.toLowerCase().includes(string) ||
            parent?.getAttribute('id')?.toLowerCase().includes(string)
        );

        return currentElement;
    }
}
